import { createClient as t, createConfig as e } from "./webchat-client10.js";
import { createClientConfig as o } from "./webchat-client8.js";
const i = /* @__PURE__ */ t(/* @__PURE__ */ o(/* @__PURE__ */ e({
  baseUrl: "https://webchat.botpress.cloud/"
})));
export {
  i as client
};
